module.exports = __webpack_public_path__ + "media/images/undraw_welcome-0e78d348491ad748e30e5e91d50eabed.svg";